"use strict";

exports.__esModule = true;
exports.default = makeLoadable;

var _react = _interopRequireDefault(require("react"));

var _reactLoadable = _interopRequireDefault(require("react-loadable"));

var _LoadingComponent = _interopRequireDefault(require("../../components/LoadingComponent/LoadingComponent"));

var _firekitProvider = _interopRequireDefault(require("firekit-provider"));

var _reactRedux = require("react-redux");

var _jsxFileName = "C:\\github\\os\\react-most-wanted\\packages\\rmw-shell\\src\\containers\\MyLoadable\\MyLoadable.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function makeLoadable(opts, preloadComponents) {
  return _reactLoadable.default.Map({
    loader: {
      Component: opts.loader,
      firebase: opts.firebase
    },
    loading: _LoadingComponent.default,

    render(loaded, props) {
      if (preloadComponents !== undefined && preloadComponents instanceof Array) {
        preloadComponents.map(component => component.preload());
      }

      const Component = loaded.Component.default;
      const firebaseApp = loaded.firebase.firebaseApp;
      return (/*#__PURE__*/_react.default.createElement(_firekitProvider.default, {
          firebaseApp: firebaseApp,
          context: _reactRedux.ReactReduxContext,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26,
            columnNumber: 9
          }
        }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 27,
            columnNumber: 11
          }
        }, /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 28,
            columnNumber: 13
          }
        }))))
      );
    }

  });
}

module.exports = exports.default;